@let orderState = store.getOrderByIdState();

<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ "ORDERS.ORDER_DETAILS" | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/orders" text="{{ 'COMMON.BACK' | translate }}" />
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  @switch (orderState.type) {
    @case ("loading") {
      <mtjr-loading />
    }
    @case ("error") {
      <mtjr-error [failure]="orderState.failure" />
    }
    @case ("success") {
      @if (store.order(); as order) {
        <ion-modal
          [isOpen]="openedChat() !== undefined"
          (willDismiss)="openedChat.set(undefined)"
          cssClass="rounded-dialog"
        >
          <ng-template>
            @if (openedChat(); as subOrder) {
              <ion-header [translucent]="true">
                <ion-toolbar>
                  <ion-buttons slot="start" class="!p-0">
                    <ion-button (click)="openedChat.set(undefined)">
                      {{ "COMMON.CLOSE" | translate }}
                      <ion-icon slot="start" name="close"></ion-icon>
                    </ion-button>
                  </ion-buttons>
                  <ion-title mode="ios">{{ "ORDERS.CHAT" | translate }}</ion-title>
                </ion-toolbar>
                <ion-toolbar>
                  <div class="flex items-start pb-2 px-3 whitespace-nowrap overflow-x-auto">
                    @for (item of subOrder.orderProducts; track $index) {
                      <div
                        class="flex items-center ps-1 pe-3 py-1 bg-light rounded-lg whitespace-nowrap me-2 flex-shrink-0"
                      >
                        <mtjr-img
                          [src]="productImage(item)"
                          [imgClass]="
                            'w-8 aspect-square rounded-lg me-4 border border-solid border-medium/30 ' +
                            (item.productType === 'digital' ? 'object-contain' : 'object-cover')
                          "
                          alt="{{ 'PRODUCTS.PRODUCT_IMAGE' | translate }}"
                        />
                        <ion-text class="text-sm text-medium">{{ item.productName }}</ion-text>
                      </div>
                    }
                  </div>
                </ion-toolbar>
              </ion-header>
              <ion-content>
                <mtjr-orders-chat [order]="order" [subOrder]="subOrder" />
              </ion-content>
            }
          </ng-template>
        </ion-modal>

        <div class="mt-6 pb-3">
          <div class="flex flex-wrap justify-center">
            <div class="w-full max-w-[750px] flex-1">
              <ion-card class="mx-6 my-2 border-none p-4 pb-2">
                <div class="mb-1 flex items-center">
                  <div class="flex flex-1 flex-col">
                    <ion-text>{{ "ORDERS.ORDER_ID" | translate }}</ion-text>
                    <ion-text color="dark" class="text-lg">{{ order.orderNo }}</ion-text>
                  </div>
                  <ion-text color="primary" class="text-lg font-bold">{{ order.total | vxCurrency }}</ion-text>
                </div>
                <div class="bg-light h-[1px] w-full"></div>
                <div class="my-2 flex items-center">
                  <ion-text color="medium" class="me-2">{{ "COMMON.DATE" | translate }}:</ion-text>
                  <ion-text color="medium" class="flex-1">{{ order.createdAt | date: "yyyy-MM-dd" }}</ion-text>
                  <ion-icon class="mx-2 text-lg" [name]="order.paymentMethod"></ion-icon>
                  <ion-text color="dark" class="font-bold">
                    {{ "ENUMS.PaymentMethod." + order.paymentMethod | translate }}
                  </ion-text>
                </div>
              </ion-card>

              @for (subOrder of order.subOrders; track $index) {
                <ion-card class="mx-6 !my-4 flex flex-col border-none ps-3 pt-2">
                  <div class="me-4 ms-1 flex items-center pb-2">
                    <div class="flex flex-1 flex-col">
                      <ion-text class="text-dark text-lg">
                        {{ subOrder.orderProducts[0].vendorName }}
                      </ion-text>
                      <mtjr-order-status-text [status]="subOrder.status" />
                      @if (subOrder.notesEn || subOrder.notesAr) {
                        <div class="mt-3">
                          <ion-text color="warning">
                            {{ { en: subOrder.notesEn ?? undefined, ar: subOrder.notesAr ?? undefined } | langSelect }}
                          </ion-text>
                        </div>
                      }
                    </div>
                    @if (
                      subOrder.status !== "shipped" &&
                      subOrder.status !== "delivered" &&
                      subOrder.status !== "canceled" &&
                      subOrder.status !== "expired"
                    ) {
                      <ion-button
                        color="danger"
                        [routerLink]="[subOrder.id, 'cancel']"
                        routerDirection="forward"
                        class="me-3"
                        size="small"
                      >
                        {{ "ORDERS.MARK_AS_CANCELED" | translate }}
                      </ion-button>
                    }

                    <ion-button fill="outline" size="small" (click)="openedChat.set(subOrder)">
                      {{ "ORDERS.CHAT" | translate }}
                      <ion-icon name="messages" slot="start"></ion-icon>
                    </ion-button>
                  </div>
                  <div class="bg-light h-[1px] w-full"></div>
                  @for (item of subOrder.orderProducts; track $index) {
                    <div class="my-3 pe-3">
                      <div class="mb-0.5 flex">
                        <mtjr-img
                          [src]="productImage(item)"
                          [imgClass]="
                            'w-20 aspect-square rounded-lg me-4 border border-solid border-medium/30 ' +
                            (item.productType === 'digital' ? 'object-contain' : 'object-cover')
                          "
                          alt="{{ 'PRODUCTS.PRODUCT_IMAGE' | translate }}"
                        />

                        <div class="mt-1 flex flex-1 flex-col">
                          <div class="flex flex-wrap justify-end pe-2 items-center gap-2">
                            <ion-text class="me-auto font-bold">
                              {{ item.productName }}
                            </ion-text>

                            @for (attr of variationAttributes(item); track $index) {
                              @if (attr.type !== "color") {
                                <div
                                  class="border-primary text-primary bg-primary/10 min-w-6 rounded-full border-[1.5px] border-solid px-2 text-center"
                                >
                                  @if (item.productType === "digital") {
                                    <ion-label color="dark" class="my-1 me-2 line-clamp-1 select-none text-white">
                                      {{ attr.label }} {{ "COMMON.CURRENCY_SYMBOL" | translate }}
                                    </ion-label>
                                  } @else {
                                    <ion-label class="text-sm">
                                      {{ "ATTRIBUTE." + attr.typeLabel.toUpperCase() | translate }} - {{ attr.label }}
                                    </ion-label>
                                  }
                                </div>
                              } @else {
                                <div
                                  fill="clear"
                                  class="border-medium !m-0 flex size-6 items-center justify-center rounded-full border-2 border-solid !p-0 text-white"
                                  [ngStyle]="{
                                    'background-color': attr.key,
                                  }"
                                ></div>
                              }
                            }
                          </div>

                          <div class="flex flex-wrap items-center justify-between">
                            <div>
                              <ion-text color="primary" class="text-md me-2 break-keep">
                                {{ item.finalPrice | vxCurrency }}
                              </ion-text>
                            </div>
                            @if (subOrder.status === "delivered") {
                              <ion-button
                                fill="clear"
                                size="small"
                                [routerLink]="['add-review', subOrder.id, item.productId]"
                                class="text-primary text-sm capitalize"
                              >
                                <ion-icon slot="start" name="star"></ion-icon>
                                {{ "FEEDBACK.PRODUCT_REVIEW" | translate }}
                              </ion-button>
                            }
                          </div>
                          <ion-text class="mt-2 font-bold">
                            {{ item.quantity }} {{ "PRODUCTS.ITEMS" | translate }}
                          </ion-text>
                        </div>
                      </div>
                    </div>
                    <div class="bg-light h-[1px] w-full"></div>
                    @if (item.metadata?.voucher?.code; as voucherCode) {
                      <div class="flex flex-col items-center justify-center">
                        <div class="flex items-center justify-center">
                          <mtjr-qrcode [qrdata]="voucherCode" [width]="150"></mtjr-qrcode>
                        </div>

                        <div
                          class="bg-primary/10 mx-4 mb-4 flex cursor-pointer rounded-md px-3 py-3"
                          (click)="copyToClipboard(voucherCode)"
                        >
                          <ion-text>{{ "ORDERS.VOUCHER_CODE" | translate }}:</ion-text>
                          <ion-text class="text-dark hover:text-primary me-1 ms-2 flex-1 font-bold">
                            {{ voucherCode }}
                          </ion-text>
                          <ion-icon name="copy-outline" class="hover:text-primary cursor-pointer"></ion-icon>
                        </div>
                      </div>
                    }
                  }
                </ion-card>
              }
              @if (!store.onlyDigitalProducts()) {
                <ion-card class="mx-6 border-none">
                  <ion-item lines="none">
                    <ion-text class="font-bold">{{ "ORDERS.DELIVERY_ADDRESS" | translate }}</ion-text>
                  </ion-item>
                  @if (order.addressStreet) {
                    <div class="bg-light ms-4 h-[1px]"></div>
                    <ion-item lines="none">
                      <ion-text>
                        {{ order.addressLabel }}
                        <span class="text-medium ms-1">{{ order.addressStreet }}</span>
                        @if (order.addressInternal) {
                          <span class="text-medium ms-1">{{ order.addressInternal }}</span>
                        }
                        <span class="text-medium ms-1">{{ order.addressPhone }}</span>
                      </ion-text>
                    </ion-item>
                  }
                </ion-card>
              }
              @if (!store.onlyDigitalProducts()) {
                <ion-card class="mx-6 pe-3 my-2 mb-3 mt-3 border-none">
                  <ion-item lines="none">
                    <ion-text class="font-bold">{{ "ORDERS.PAYMENT_INFO" | translate }}</ion-text>
                  </ion-item>
                  <div class="bg-light ms-4 h-[1px]"></div>
                  <div class="p-4">
                    <div class="flex">
                      <ion-text color="medium" class="flex-1">{{ "ORDERS.SUB_TOTAL" | translate }}</ion-text>
                      <ion-text color="dark" class="font-bold">{{ order.subTotal | vxCurrency }}</ion-text>
                    </div>
                    <div class="mt-4 flex">
                      <ion-text color="medium" class="flex-1">{{ "ORDERS.TOTAL" | translate }}</ion-text>
                      <ion-text color="dark" class="font-bold">{{ order.total | vxCurrency }}</ion-text>
                    </div>
                  </div>
                </ion-card>
              }
            </div>
          </div>
        </div>
      }
    }
  }
</ion-content>
